const componentType = {
  group: 'group',
  text: 'text'
}

export { componentType }
